import { isAdminUser, isOfficerUser, isCoordinatorUser, isObserverUser } from "~/shared/adminAbilities"

export const useAdminRoles = async () => {
  const isAdminRole = await allows(isAdminUser)
  const isOfficerRole = await allows(isOfficerUser)
  const isCoordinatorRole = await allows(isCoordinatorUser)
  const isObserverRole = await allows(isObserverUser)

  return { isAdminRole, isOfficerRole, isCoordinatorRole, isObserverRole }
}
